import { render, staticRenderFns } from "./CleaningConfigurationSummary.vue?vue&type=template&id=54a91e80&scoped=true"
import script from "./CleaningConfigurationSummary.vue?vue&type=script&lang=js"
export * from "./CleaningConfigurationSummary.vue?vue&type=script&lang=js"
import style0 from "./CleaningConfigurationSummary.vue?vue&type=style&index=0&id=54a91e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a91e80",
  null
  
)

export default component.exports